import React from "react";

interface LoadingOverlayProps {
    message?: string;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ message = "Đang tải dữ liệu..." }) => {
    return (
        <div className="fixed inset-0 flex flex-col items-center justify-center bg-white/10 backdrop-blur-sm z-[100]">
            <div className="relative">
                <div className="w-14 h-14 border-4 border-blue-300 rounded-full animate-spin border-t-blue-600"></div>
            </div>
            <p className="mt-4 text-gray-700 text-lg font-medium animate-pulse">
                {message}
            </p>
        </div>
    );
};

export default LoadingOverlay;
